import Vue from 'vue'
import App from '../components/store-btn/App.vue';
import { Validator } from 'vee-validate';
import VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';

import 'sweetalert2/dist/sweetalert2.min.css';

Validator.extend('phone', {
    validate: value => value.toString().replaceAll('-', '').replaceAll('(', '').replaceAll(')', '').replaceAll('+', '').replaceAll(' ', '').length >= 10
});

Vue.use(VeeValidate, { inject: false });
Vue.use(VueSweetalert2);

const containers = document.querySelectorAll(`div[id^="store-btns-"]`);

containers.forEach((container) => {
    document.addEventListener('DOMContentLoaded', () => {
        const app = new Vue({
            render: h => h(App, {
                props: {
                    cta: cta,
                    promotionSlug: container.dataset.form,
                    downloadThanksText: downloadThanksText
                }
            })
        }).$mount(`#${container.id}`)
    })
})